<template>
  <v-flex xs6 class="ml-1">
    <v-card class="mb-2">
      <v-card-title class="mb-2">
        <v-avatar class="secondary">
          <v-icon dark>business</v-icon>
        </v-avatar>
        <div class="ml-3">
          <h4 class="headline">BBB Product Term</h4>
          <span class="body-2">Used for calculating fees for designated leads</span>
        </div>
      </v-card-title>
      <v-card flat>
        <v-card-text>
          <v-container grid-list-md>
            <v-form lazy-validation>
              <v-layout wrap>
                <v-flex xs12 sm6>
                  <v-select
                    :items="BBBProductTerms"
                    item-text="name"
                    item-value="id"
                    v-model="bbbProductTermId"
                    hide-selected
                    placeholder="Assign BBB Product Term"
                    dense
                  ></v-select>
                </v-flex>
                <v-flex xs6 sm3></v-flex>
                <v-flex xs6 sm3 class="text-md-right"
                  ><v-btn color="accent" @click.native="update">Update</v-btn></v-flex
                >
              </v-layout>
            </v-form>
          </v-container>
        </v-card-text>
      </v-card>
    </v-card>
  </v-flex>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'bbbProductTerm',
  data: () => ({
    bbb_product_term_id: null
  }),
  computed: {
    ...mapGetters(['SelectedFunder', 'BBBProductTerms']),
    bbbProductTermId: {
      get() {
        return this.SelectedFunder.bbb_product_term_id;
      },
      set(id) {
        this.bbb_product_term_id = id;
      }
    }
  },
  methods: {
    ...mapActions(['getBBBProductTerms', 'updateProduct']),
    update() {
      this.updateProduct({
        id: this.SelectedFunder.id,
        updates: {
          bbb_product_term_id: this.bbb_product_term_id
        }
      });
    }
  },
  mounted() {
    this.getBBBProductTerms();
  }
};
</script>

<style lang="scss" scoped></style>
